<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title
        :title="$t('message.aside.profil', { value: 'default' })"
      ></portal-title>
      <portal-breadcumb></portal-breadcumb>
      <div class="content">
        <!-- BEGIN PROFIL CARD-->
        <v-card outlined>
          <v-card-title class="portal-green-bg">
            <span>{{ customerName }}</span>
            <!--<span
              class="ml-5 pl-5"
              @click="dialog = true"
              style="cursor: pointer"
            >
              -- Modifier
              <v-icon color="#fff" class="ml-auto"> mdi-pencil </v-icon></span
            >-->
            <v-icon color="#fff" class="ml-auto"> mdi-account-circle </v-icon>
          </v-card-title>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>{{ $t("message.home.name", { value: "default" }) }} & {{ $t("message.home.firstname", { value: "default" }) }}</th>
                    <th>
                      {{ $t("message.home.mobilephone", { value: "default" }) }}
                    </th>
                    <th>{{ $t("message.home.mail", { value: "default" }) }}</th>
                    <th>
                      {{ $t("message.superuser.profile", { value: "default" }) }}
                    </th>
                    <th v-if="auth.superuser">
                      {{ $t("message.superuser.action", { value: "default" }) }}
                    </th>                    
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in datasTable" :key="item.id">
                    <td>{{ item.name }}</td>
                    <td>{{ item.telephone }}</td>
                    <td>{{ item.mail }}</td>
                    <td>
                        <div v-if="item.fonction === 'admin'">
                          {{ $t("message.superuser.administrator", { value: "default" }) }}
                        </div>
                        <div v-else-if="item.fonction === 'mgt'">
                          {{ $t("message.superuser.management", { value: "default" }) }}
                        </div>
                        <div v-else-if="item.fonction === 'oper'">
                          {{ $t("message.superuser.operational", { value: "default" }) }}
                        </div>
                        <div v-else-if="item.fonction === 'com'">
                          {{ $t("message.superuser.commercial", { value: "default" }) }}
                        </div>  
                        <div v-else>
                          {{ $t("message.superuser.operational", { value: "default" }) }}
                        </div>                    
                    </td>
                    <td v-if="auth.superuser">
                      <v-icon class="me-2" @click="editUser(item)">mdi-pencil</v-icon>
                      <v-icon @click="deleteUser(item)"> mdi-delete  </v-icon>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
        <!-- END PROFIL CARD-->

        <!-- BEGIN TEAM CARD-->
        <v-card style="margin-top: 30px" elevation="1">
          <v-card-title class="portal-deep-blue-bg">
            {{ $t("message.home.team", { value: "default" }) }}
            <v-icon color="#fff" class="ml-auto"> mdi-account-multiple </v-icon>
          </v-card-title>

          <v-card-text>
            <v-row>
              <div class="ml-3 pl-6 pr-6 tm pt-14" style="background: #fafafa">
                <div class="info-profil-header pb-10">
                  <div>
                    <h4>
                      {{ $t("message.home.name", { value: "default" }) }} /
                      {{ $t("message.home.firstname", { value: "default" }) }}
                    </h4>
                  </div>
                  <div>
                    {{ $t("message.home.function", { value: "default" }) }}
                  </div>
                  <div>
                    {{ $t("message.home.fixphone", { value: "default" }) }}
                  </div>
                  <div>
                    {{ $t("message.home.mobilephone", { value: "default" }) }}
                  </div>
                  <div>{{ $t("message.home.mail", { value: "default" }) }}</div>
                </div>
              </div>
              <v-col class="pb-0">
                <v-carousel
                  hide-delimiters
                  height="280"
                  show-arrows-on-hover
                  cycle
                >
                  <template v-slot:prev="{ on, attrs }">
                    <v-btn
                      color="#fff"
                      v-bind="attrs"
                      v-on="on"
                      fab
                      x-small
                      elevation="0"
                    >
                      <v-icon color="#00475a" size="42">
                        mdi-chevron-left
                      </v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:next="{ on, attrs }">
                    <v-btn
                      color="#fff"
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      fab
                      elevation="0"
                    >
                      <v-icon color="#00475a" size="42">
                        mdi-chevron-right
                      </v-icon>
                    </v-btn>
                  </template>
                  <template v-for="(team, idx) in teams">
                    <v-carousel-item
                      v-if="(idx + 1) % 4 === 1"
                      :key="idx"
                      class="mb-0 pb-0 pt-0"
                    >
                      <v-row class="mr-0 mt-0 mb-0 ml-0" style="height: 100%">
                        <template v-for="(n, i) in 4">
                          <template v-if="+idx + i < teams.length">
                            <v-col md="3" :key="i" class="tm mt-0">
                              <v-sheet color="#fff" class="pb-0">
                                <portal-team-item
                                  :item="teams[+idx + i]"
                                ></portal-team-item>
                              </v-sheet>
                            </v-col>
                          </template>
                        </template>
                      </v-row>
                    </v-carousel-item>
                  </template>
                </v-carousel>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- END TEAM CARD-->
      </div>

      <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        max-width="600"
      >
        <v-card>
          <v-toolbar color="#00475a" dark>Informations personnelles</v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row class="mt-2">
                <v-col md="4" class="label-field">
                  {{ $t("message.home.name", { value: "default" }) }}:
                </v-col>
                <v-col>
                  <v-text-field
                    dense
                    outlined
                    :rules="requiredRules"
                    hide-details="auto"
                    v-model="user.name"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col md="4" class="label-field">
                  {{ $t("message.home.firstname", { value: "default" }) }}:
                </v-col>
                <v-col>
                  <v-text-field
                    dense
                    outlined
                    :rules="requiredRules"
                    hide-details="auto"
                    v-model="user.surname"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col md="4" class="label-field">
                  {{ $t("message.home.function", { value: "default" }) }}:
                </v-col>
                <v-col>
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="user.surname"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col md="4" class="label-field">
                  {{ $t("message.home.mobilephone", { value: "default" }) }}:
                </v-col>
                <v-col>
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="user.surname"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col md="4" class="label-field">
                  {{ $t("message.home.mail", { value: "default" }) }}:
                </v-col>
                <v-col>
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="user.surname"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col md="4" class="label-field">
                  {{ $t("message.header.language", { value: "default" }) }}:
                </v-col>
                <v-col>
                  <v-select :items="langs" hide-details="auto" outlined dense>
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-dialog v-model="edituserDialog" width="800" scrollable overlay-color="#fff" overlay-opacity="0.5">
      <portal-edituser :user="userToEdit" v-on:editClose="closeEdit"></portal-edituser>
    </v-dialog>

    <v-dialog v-model="deleteuserDialog" width="850" scrollable overlay-color="#fff" overlay-opacity="0.5">
      <portal-deleteuser :user="userToDelete" v-on:deleteClose="closeDelete"></portal-deleteuser>
    </v-dialog>

  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import PortalTeamItem from "@/components/PortalTeamItem.vue";
import TeamsService from "@/services/TeamsService";
import { mapGetters, mapActions } from "vuex";
import PortalEdituser from "@/components/PortalEdituser";
import PortalDeleteuser from "@/components/PortalDeleteuser";

export default {
  title: "Profil info",
  name: "TeamPage",
  watch: {
    getterCurrentClient: function () {
      this.getCustomer();
      this.getTeams();
      this.getUsersClient();
    },
  },
  methods: {
   
    ...mapActions("customer", {
      actionGetCustomer: "loadCustomer",
      actionGetTeams: "loadTeams",
    }),

    async getCustomer() {
      await this.actionGetCustomer(this.getterCurrentClient);
      if (this.getterAdUser) {
        this.customerName = "AKIEM";
      } else {
        this.customerName = this.getterCustomer.name;
      }
    },

    async getTeams() {
      await this.actionGetTeams(this.getterCurrentClient);
      this.teams = this.getterTeams;
    },

    async getUsersClient() {
      TeamsService.getUsersClient(this.getterCurrentClient).then((response) => {
        this.datasTable = response.data
      })
    },

    deleteUser(user) {
      this.userToDelete = user;
      this.deleteuserDialog = true;
    },

    editUser(user) {
      console.log(user)
      this.userToEdit = user;
      console.log(this.userToEdit)
      this.edituserDialog = true;
    },

    closeEdit() {
      this.edituserDialog = false;
      this.getUsersClient();
      this.isAuthorized();
    },

    closeDelete() {
      this.getUsersClient();
      this.deleteuserDialog = false;
    },

    isAuthorized() {  
        if (this.getterFunctionnalities.includes("Administrator")) {
            this.auth = {
                superuser: true
            };
        }
    },
  },
  data: () => ({
    langs: [],
    title: "INFOS PROFIL",
    customerName: "",
    dialog: false,
    valid: true,
    requiredRules: [(v) => !!v || "This field is required"],
    teams: [],
    datasTable: [],
    user: {
      name: "Toto",
      profil: "CAF",
      telephone: "01234567",
      mail: "toto@akiem.com",
    },
    edituserDialog: false,
    deleteuserDialog: false,
    userToEdit: "",
    userToDelete: null,
    auth: {
      superuser: false,
    },
  }),
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    PortalTeamItem,
    PortalEdituser,
    PortalDeleteuser,
  },
  mounted() {
    this.getCustomer();
    this.getTeams();
    this.getUsersClient();
    this.isAuthorized();
  },

  filters: {
    name: function (value) {
      if (value == null) {
        return "";
      }
      const words = value.split(" ", 2);
      if (words.length > 1) {
        return words[1];
      }
    },

    surname: function (value) {
      if (value == null) {
        return "";
      }
      const words = value.split(" ", 2);
      if (words.length > 1) {
        return words[0];
      }
    },
  },
  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterAuthData: "getAuthData",
      getterAdUser: "isAdUser",
      getterFunctionnalities: "getFunctionnalities"
    }),
    ...mapGetters("customer", {
      getterCustomer: "getCustomer",
      getterTeams: "getTeams",
    }),
  },
};
</script>

<style scoped>
.tm {
  border-right: 1px solid #ccd2d5;
  padding: 0px;
  padding-top: 0px;
  margin: 0px;
  margin-bottom: 0px;
  margin-top: 12px;
}

.tm:nth-child(4n) {
  border-right: none;
}

.info-profil-header {
  font-size: 15px;
}

.info-profil-header > div {
  padding-top: 10px;
  height: 35px;
}

.portal-green-bg {
  height: 59px;
  color: #fff;
}

thead {
  background-color: #fafafa;
  color: #9faaaf;
}

tbody {
  color: #00475a;
  font-weight: bolder;
}

.portal-deep-blue-bg {
  height: 59px;
  color: #fff;
}

.v-card__text {
  padding: 0px;
}

th,
td {
  border-left: 1px solid #ccd2d5;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}
</style>
